import React from 'react';
import { Link } from 'react-router-dom';

import fullViewDrone from '../../../main/assets/images/mrm1-5/mrm1-5-product.webp';

export const ForgeOperators = () => (
  <section className="careprogram__section">
    <div className="careprogram__content--wrapper-mrm1">
      <div className="careprogram__box--wrapper-mrm careprogram__box--wrapper-mrm1 responsive__padding">
        <div className="title__column--gap">
          <h2 className="dreamX__title">LEARN MORE</h2>
        </div>
        <p className="dreamX__body">
          The bottom line is the{' '}
          <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> is an
          ultra-reliable platform ideally suited to both training and multi-role
          missions. If that sounds good then contact our team to discuss your
          exact requirements.
        </p>
        <div>
          <Link
            to="/contact?product=mrm1-5"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            Contact Us
          </Link>
        </div>
        <div className="careprogram__image--wrapper careprogram__image--wrapper-mrm1">
          <img
            src={fullViewDrone}
            alt="MRM1-5 Tactical Asset Without Payload"
            className="careprogram__image--mobile-mrm1"
          />
        </div>
      </div>
    </div>
  </section>
);
